import { Card } from './Card'

import { useIntl } from 'react-intl'
import compliance from '../../../../assets/images/compliance.png'
import contactWithUs from '../../../../assets/images/contact-with-us.png'
import handsOn from '../../../../assets/images/hands-on.png'
import quickTurnaroundTime from '../../../../assets/images/quick-turnaround-time.png'
import tailorMade from '../../../../assets/images/tailor-made.png'

type Props = {
  id: string
}

export const WhyUs = ({ id }: Props) => {
  const { formatMessage } = useIntl()

  return (
    <section id={id} className="bg-[#CEE2ED] py-[100px]">
      <div className="text-justify max-w-[1264px] mx-auto">
        <h2 className="px-4 text-2xl md:text-[36px] mb-10 text-center uppercase font-openSans text-[#068A8A] font-bold">
          {formatMessage({ id: 'WHY_US' })}
        </h2>

        <div className="flex w-full gap-8 px-4 overflow-x-scroll slides scrolltransparent">
          <div className="flex gap-8 slide animate-scroll scroll">
            <Card
              title={formatMessage({ id: 'WHY_US_CARD_1_TITLE' })}
              description={formatMessage({ id: 'WHY_US_CARD_1_TEXT' })}
              bgImg={quickTurnaroundTime}
            />
            <Card
              title={formatMessage({ id: 'WHY_US_CARD_2_TITLE' })}
              description={formatMessage({ id: 'WHY_US_CARD_2_TEXT' })}
              bgImg={contactWithUs}
            />
            <Card
              title={formatMessage({ id: 'WHY_US_CARD_3_TITLE' })}
              description={formatMessage({ id: 'WHY_US_CARD_3_TEXT' })}
              bgImg={handsOn}
            />
            <Card
              title={formatMessage({ id: 'WHY_US_CARD_4_TITLE' })}
              description={formatMessage({ id: 'WHY_US_CARD_4_TEXT' })}
              bgImg={compliance}
            />
            <Card
              title={formatMessage({ id: 'WHY_US_CARD_5_TITLE' })}
              description={formatMessage({ id: 'WHY_US_CARD_5_TEXT' })}
              bgImg={tailorMade}
            />
          </div>
          <div className="flex gap-8 slide animate-scroll">
            <Card
              title={formatMessage({ id: 'WHY_US_CARD_1_TITLE' })}
              description={formatMessage({ id: 'WHY_US_CARD_1_TEXT' })}
              bgImg={quickTurnaroundTime}
            />
            <Card
              title={formatMessage({ id: 'WHY_US_CARD_2_TITLE' })}
              description={formatMessage({ id: 'WHY_US_CARD_2_TEXT' })}
              bgImg={contactWithUs}
            />
            <Card
              title={formatMessage({ id: 'WHY_US_CARD_3_TITLE' })}
              description={formatMessage({ id: 'WHY_US_CARD_3_TEXT' })}
              bgImg={handsOn}
            />
            <Card
              title={formatMessage({ id: 'WHY_US_CARD_4_TITLE' })}
              description={formatMessage({ id: 'WHY_US_CARD_4_TEXT' })}
              bgImg={compliance}
            />
            <Card
              title={formatMessage({ id: 'WHY_US_CARD_5_TITLE' })}
              description={formatMessage({ id: 'WHY_US_CARD_5_TEXT' })}
              bgImg={tailorMade}
            />
          </div>
        </div>
      </div>
    </section>
  )
}
